import ChatIcon from '@mui/icons-material/Chat';
import { Box, ClickAwayListener, Typography } from '@mui/material';
import Portal from '@mui/material/Portal';
import { useAtom } from 'jotai';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { createCommentAtom } from '@/atoms/comments';
import { useCommentsDrawer } from '@/comments';

export const CreateCommentTooltip = () => {
    const { t } = useTranslation();
    const [, drawerActions] = useCommentsDrawer();
    const ref = useRef(null);
    const [comment, setCreateComment] = useAtom(createCommentAtom);

    if (!comment) {
        return null;
    }

    const {
        rectTop,
        rectLeft,
        rectWidth,
        model,
        id,
        text,
        position,
        filter,
        textAtomContent,
        selectionIndex,
        group,
        isOverlappingOtherComment,
    } = comment;

    const TooltipContent = () =>
        isOverlappingOtherComment ? (
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: '10px 24px',
                }}
            >
                <Typography variant="body1" color={theme => theme.palette.primary.main}>
                    {t('comment.already-comment')}
                </Typography>
            </Box>
        ) : (
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: '10px 24px',
                    gap: '20px',
                    cursor: 'pointer',
                }}
                onClick={_e => {
                    drawerActions.openWithQuote({
                        commentableId: id,
                        commentableModel: model,
                        text,
                        position,
                        filter,
                        textAtomContent,
                        selectionIndex,
                        group,
                    });
                    setCreateComment(null);
                }}
            >
                <Typography variant="body1" color={theme => theme.palette.primary.main}>
                    {t('comment.comment')}
                </Typography>
                <div className="leading-[0]">
                    <ChatIcon sx={{ color: theme => theme.palette.primary.main }} />
                </div>
            </Box>
        );

    return (
        <Portal>
            <ClickAwayListener onClickAway={() => setCreateComment(null)}>
                <Box
                    ref={ref}
                    sx={{
                        top: rectTop - 52,
                        left: rectLeft + rectWidth / 2 - 80,
                        border: '1px solid #726c7e1a',
                        boxShadow: '0px 14px 14px #47475c14',
                        background: theme => (theme.palette.mode === 'dark' ? theme.custom.c3 : theme.custom.c22),
                        backdropFilter: 'blur(45px)',
                        position: 'absolute',
                        borderRadius: '12px',
                        zIndex: '99999',
                    }}
                >
                    <TooltipContent />
                </Box>
            </ClickAwayListener>
        </Portal>
    );
};
